import type { MembershipRoleChoiceResponse } from "@kontextwerk/control-web-client"
import type { UserCreateForm, UserDataStepOutput } from "./contract"

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** The employee system role is preselected; without one the role stays an explicit choice. */
export const defaultInviteRoleId = (choices: readonly MembershipRoleChoiceResponse[]): string =>
  choices.find((choice) => choice.kind === "employee")?.id ?? ""

export const createUserCreateForm = (
  choices: readonly MembershipRoleChoiceResponse[],
): UserCreateForm => ({
  email: "",
  roleId: defaultInviteRoleId(choices),
})

export const validateUserDataStep = ({
  form,
  choices,
}: {
  form: UserCreateForm
  choices: readonly MembershipRoleChoiceResponse[]
}): { ok: true; output: UserDataStepOutput } | { ok: false; message: string } => {
  const email = form.email.trim()

  if (!email) return { ok: false, message: "Bitte E-Mail angeben." }

  if (email.length > 320 || !EMAIL_PATTERN.test(email))
    return { ok: false, message: "Bitte eine gültige E-Mail-Adresse angeben." }

  const role = choices.find((choice) => choice.id === form.roleId)

  if (!role) return { ok: false, message: "Bitte eine Rolle auswählen." }

  return { ok: true, output: { email, role } }
}
